import Image from 'next/image'
import NavigationItem from './NavigationItem'
import BPTWalletItem from './BPTWalletItem'
import ConnectWalletItem from './ConnectWalletItem'
import HStack from '@/components/core/HStack/HStack'
import { Link, useLocation } from '@tanstack/react-router'
import { useAccount } from 'wagmi'

const NAVIGATION_ITEMS = [
    {
        label: 'Play',
        target: '/play',
        isSelected: true,
    },
    {
        label: 'Earn',
        target: '/earn',
    },
    {
        label: 'Referrals',
        target: '/referrals',
    },
    {
        label: 'Governance',
        target: '/governance',
    },
    {
        label: 'Docs',
        target: '/docs',
    }
]

export default function Header() {
    const { address } = useAccount()
    const location = useLocation()
    const pathname = location.pathname

    return (
        <div className='@container w-full bg-[#212439] border-b border-gray-700'>
            <div className='w-full @min-xs:max-w-[1348px] mx-auto h-20 flex items-center justify-between'>
                <div className='flex items-center gap-16'>
                    <Link to='/play'>
                        <Image src='/assets/svgs/logo-with-text.svg' alt='BlockPot Logo' width={160} height={40} />
                    </Link>

                    <div className='flex items-center gap-10'>
                        {NAVIGATION_ITEMS.map((item) => (
                            <NavigationItem key={item.label} target={item.target} isSelected={pathname.includes(item.target)}>
                                {item.label}
                            </NavigationItem>
                        ))}
                    </div>
                </div>
                <HStack className='gap-4'>
                    { address && <BPTWalletItem /> }
                    <ConnectWalletItem />
                </HStack>
            </div>
        </div>
    )
}